const SKILL_ORDER_KEY = 'talent-skill-order';

/**
 * profileId 기준으로 특기 순서를 localStorage에 저장
 * @param {string|number} profileId
 * @param {string[]} skills - 저장할 순서대로 정렬된 특기 이름 배열
 */
export function saveSkillOrder(profileId, skills) {
  if (!profileId) return;
  try {
    const raw = localStorage.getItem(SKILL_ORDER_KEY);
    const all = raw ? JSON.parse(raw) : {};
    all[String(profileId)] = skills;
    localStorage.setItem(SKILL_ORDER_KEY, JSON.stringify(all));
  } catch {}
}

/**
 * profileId 기준으로 저장된 특기 순서를 적용
 * @param {string|number} profileId
 * @param {string[]} skills
 * @returns {string[]}
 */
export function applySkillOrder(profileId, skills) {
  if (!profileId || !skills || skills.length === 0) return skills;
  try {
    const raw = localStorage.getItem(SKILL_ORDER_KEY);
    if (!raw) return skills;
    const all = JSON.parse(raw);
    const savedOrder = all[String(profileId)];
    if (!savedOrder || savedOrder.length === 0) return skills;
    const rank = new Map(savedOrder.map((name, i) => [name, i]));
    return [...skills].sort((a, b) => {
      const ra = rank.has(a) ? rank.get(a) : Number.MAX_SAFE_INTEGER;
      const rb = rank.has(b) ? rank.get(b) : Number.MAX_SAFE_INTEGER;
      return ra - rb;
    });
  } catch {
    return skills;
  }
}
